import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="app--user-facilitator-form"
export default class extends Controller {
	static targets = [
		'newFacilitatorSection',
		'formSection',
		'createFacilitatorInput'
	]

	static values = {
		facilitatorExists: Boolean,
	}

	connect() {
		this.updateNewFacilitatorSection()
		this.updateFormSection()
	}

	updateNewFacilitatorSection() {
		if (this.facilitatorExistsValue) {
			this.newFacilitatorSectionTarget.classList.add('d-none')
		} else {
			this.newFacilitatorSectionTarget.classList.remove('d-none')
		}
	}

	updateFormSection(_event) {
		if (this.facilitatorExistsValue || this.createFacilitatorInputTarget.checked) { 
			this.formSectionTarget.classList.remove('d-none')

			this.formSectionTarget
				.querySelectorAll('input, select')
				.forEach( (element) => element.disabled = false )
		} else {
			this.formSectionTarget.classList.add('d-none')

			this.formSectionTarget
				.querySelectorAll('input, select')
				.forEach( (element) => element.disabled = true )
		}
	}
}
